<template>
  <section
    v-if="faq.length"
    id="faq-section"
    class="faq-section w-full my-8 lg:my-10"
  >
    <ProductAnchorTitle
      class="mb-4"
      :title="$t('Frequently asked questions')"
    />
    <div
      v-for="(item, index) in faq"
      :key="index"
      class="rounded-lg"
      :class="[
        {
          'opacity-0 pointer-events-none h-0 p-0': hideExcessiveItems(index),
          'p-4 mt-2 border': !hideExcessiveItems(index)
        }
      ]"
    >
      <h3 class="mb-3 text-base text-EXPONDO-black">
        {{ item.question }}
      </h3>
      <div class="text-EXPONDO-grey">
        <RichText
          :rich-text="item.answer"
          :with-margin="false"
          :with-no-inner-margins="true"
        />
      </div>
    </div>
    <button
      v-if="faq.length >= showMaxItems"
      class="w-full mt-4 h-9 flex justify-center items-center bg-EXPONDO-grey-5 rounded-md"
      :class="{ hidden: faq.length <= showMaxItems }"
      @click="toggleShowMore"
    >
      <span
        class="iconify svg--chevron-right text-EXPONDO-primary"
        :class="[
          {
            'rotate-90': !showMore,
            'rotate-[-90deg]':showMore
          }
        ]"
      />
    </button>
  </section>
</template>

<script lang="ts">

import type { FaqAccordionItem } from '~~/types/cms/AccordionItem';

export default defineComponent({
  name: 'FaqSection',

  props: {
    faq: {
      type: Array as PropType<FaqAccordionItem[]>,
      required: true,
    },
  },
  setup() {

    const showMore = ref(false);
    const showMaxItems = 5;

    const hideExcessiveItems = (index: number) => index >= showMaxItems && !showMore.value;

    const toggleShowMore = () => {

      showMore.value = !showMore.value;

    };

    return {
      showMore,
      showMaxItems,
      toggleShowMore,
      hideExcessiveItems,
    };

  },
});

</script>

<style lang="scss">
.faq-section {
  max-width: var(--container-max-width);
}
</style>
